module.exports = __webpack_public_path__ + "static/media/2.866db564.png";